<template>
  <div class="relative">
    <div ref="lineChart" class="w-full h-full"></div>
    <div class="icon-wrapper">
        <el-radio-group v-model="chartType" @change="updateChartType" size="mini">
          <el-radio-button label="bar">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="13" width="4" height="8" fill="currentColor"/>
              <rect x="10" y="9" width="4" height="12" fill="currentColor"/>
              <rect x="17" y="5" width="4" height="16" fill="currentColor"/>
            </svg>
          </el-radio-button>
          <el-radio-button label="line">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 17L9 11L13 15L21 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <circle cx="9" cy="11" r="1" fill="currentColor"/>
              <circle cx="13" cy="15" r="1" fill="currentColor"/>
              <circle cx="21" cy="7" r="1" fill="currentColor"/>
            </svg>
          </el-radio-button>
        </el-radio-group>
      </div>
  </div>

</template>

<script>
import * as echarts from 'echarts/core';
import { LineChart, BarChart } from 'echarts/charts';
import { TitleComponent, TooltipComponent, GridComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([TitleComponent, TooltipComponent, GridComponent, LineChart, BarChart, CanvasRenderer]);


export default {
  name: 'LineChart',
  props: {
    chartData: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      chart: null,
      chartType: 'line',
    }
  },
  watch: {
    chartData: {
      handler(newData) {
        this.updateChartData(newData);
      },
      deep: true
    },
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.lineChart);
      this.updateChartData(this.chartData);
    },
    updateChartData(data) {
      let option = this.generateOptions(data.dateList, data.usedList, data.residualList);
      this.chart.setOption(option);
    },

    generateOptions(dateList, usedList, residualList) {
      let used = this.$t("dashboard.rotating.chart.used");
      let residual = this.$t("dashboard.rotating.chart.residual");
      let selected = {}
      selected[used] = true;
      selected[residual] = false;
      return {
        legend: {
          data: [used, residual],
          selected: selected,
          left: "22px",
          icon: "rect",
          itemWidth: 17,
          itemHeight: 17,
          itemGap: 35,
          top: "10px",
          textStyle: { fontSize: 12, color: "#4a525f", padding: [1, 0, 0, 3] },
          selectedMode: "multiple",
        },
        grid: {
          top: "60px",
          left: "22px",
          right: "3%",
          bottom: "20px",
          containLabel: !0,
        },
        tooltip: { trigger: "axis" },
        xAxis: {
          type: "category",
          axisTick: { show: !1 },
          axisLine: { show: !1 },
          data: dateList,
        },
        yAxis: {
          type: "value",
          axisLabel: { formatter: "{value} M" },
          nameTextStyle: {
            verticalAlign: "bottom",
            padding: [0, 50, 20, 0],
            fontSize: 0,
            fontWeight: "bold",
          },
          splitLine: { lineStyle: { color: ["#e9ebef"] } },
          axisTick: { show: !1 },
          axisLine: { show: !1 },
        },
        series: [
          { name: used, data: usedList, smooth: true, type: this.chartType, color: "#276dfd" },
          { name: residual, data: residualList, smooth: true, type: this.chartType, color: "#f9a84b"},
        ],
      };
    },
    updateChartType() {
      const option = this.chart.getOption();
      option.series.forEach(series => {
        series.type = this.chartType;
      });
      this.chart.setOption(option);
    }
  }
};
</script>

<style scoped>
.icon-wrapper {
  position: absolute;
  top: -40px;
  left: 150px;
  display: flex;
  gap: 6px;  
}

</style>